var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "PatientRegistrationModal",
        role: "dialog",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog wider-1" }, [
        _c("div", { staticClass: "modal-content room-book-modal" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function ($event) {
                    return _vm.closeBookAppointment("closepopup")
                  },
                },
              },
              [_vm._v("×")]
            ),
          ]),
          _c("div", { staticClass: "modal-body " }, [
            _vm.isAbhaEnabled
              ? _c(
                  "div",
                  {
                    staticClass: "clearfix d-flex justify-content-center mb-5",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "primary-btn ripple mr-4",
                        on: {
                          click: function ($event) {
                            return _vm.navigatetomonecreate()
                          },
                        },
                      },
                      [_vm._v("Create ABHA")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "primary-btn ripple",
                        on: {
                          click: function ($event) {
                            return _vm.navigatetomoneverify()
                          },
                        },
                      },
                      [_vm._v("Already has ABHA")]
                    ),
                  ]
                )
              : _vm._e(),
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(
                _vm._s(
                  _vm.isEditMode
                    ? "Update Patient Details"
                    : "Patient Registration"
                )
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-2 pr-0" }, [
                    _c(
                      "form",
                      {
                        staticClass: "select-dots",
                        class: { "disable-hold": _vm.selectededitappointment },
                      },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.countrycode,
                                expression: "countrycode",
                              },
                            ],
                            staticClass: "country-code",
                            class: _vm.mobHasfocus ? "country-c" : "",
                            attrs: {
                              name: "",
                              id: "cusSelectbox",
                              "data-toggle": "tooltip",
                              disabled: _vm.isEditMode,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.countrycode = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                _vm.setCcode,
                              ],
                              focusin: function ($event) {
                                return _vm.mobfocus(true)
                              },
                              focusout: function ($event) {
                                return _vm.mobfocus(false)
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  "data-countrycode": "IN",
                                  value: "91",
                                },
                              },
                              [_vm._v("India (+91)")]
                            ),
                            _c(
                              "option",
                              {
                                attrs: {
                                  "data-countrycode": "GB",
                                  value: "44",
                                },
                              },
                              [_vm._v("UK (+44)")]
                            ),
                            _c(
                              "option",
                              {
                                attrs: { "data-countrycode": "US", value: "1" },
                              },
                              [_vm._v("USA (+1)")]
                            ),
                            _vm._m(0),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "col-2 px-0" }, [
                    _c("input", {
                      staticClass: "w-100 px-2",
                      class: _vm.mobHasfocus ? "country-c" : "",
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.countrycode },
                      on: {
                        change: _vm.setCcode,
                        focusin: function ($event) {
                          return _vm.mobfocus(true)
                        },
                        focusout: function ($event) {
                          return _vm.mobfocus(false)
                        },
                      },
                    }),
                  ]),
                  _vm.abhaprofile == null
                    ? _c("div", { staticClass: "col-8" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: {
                              "disable-hold": _vm.selectededitappointment,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "container-comm",
                                class: {
                                  "error-msg-hold": _vm.usermobilenumber,
                                },
                              },
                              [
                                this.selectededitappointment
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.customermobile,
                                          expression: "customermobile",
                                        },
                                      ],
                                      staticClass: "mobi-num ",
                                      attrs: {
                                        type: "text",
                                        autocomplete: "off",
                                        name: "uname",
                                        required: "",
                                      },
                                      domProps: { value: _vm.customermobile },
                                      on: {
                                        keypress: _vm.allowOnlyNumbers,
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.customermobile =
                                            $event.target.value
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                !this.selectededitappointment
                                  ? _c("v-autocomplete", {
                                      ref: "newCustomer_autocomplete",
                                      style: _vm.readonlyparentdata
                                        ? { color: "rgba(29, 29, 29, 0.45)" }
                                        : {},
                                      attrs: {
                                        name: "Mobile Number",
                                        "data-vv-delay": "300",
                                        "auto-select-one-item": false,
                                        "get-label": _vm.getLabel,
                                        items: _vm.customers,
                                        "component-item": _vm.gtemplate,
                                        "input-attrs": {
                                          id: "registerpatientautoselect",
                                          class: "mobi-num form-control input",
                                          maxlength: 10,
                                        },
                                        disabled:
                                          _vm.readonlyparentdata ||
                                          _vm.isEditMode,
                                      },
                                      on: {
                                        "update-items": _vm.updateItems,
                                        "item-selected": _vm.customer_selected,
                                        focus: function ($event) {
                                          return _vm.mobfocus(true)
                                        },
                                        blur: function ($event) {
                                          return _vm.mobfocus(false)
                                        },
                                        change: _vm.checkValue,
                                      },
                                      nativeOn: {
                                        keypress: function ($event) {
                                          return _vm.allowOnlyDigits.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.customer,
                                        callback: function ($$v) {
                                          _vm.customer = $$v
                                        },
                                        expression: "customer",
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "label",
                                  {
                                    class: {
                                      "animate-label-t": _vm.mobHasfocus,
                                      "animate-label-t t-valid":
                                        _vm.mobHasfocusout &&
                                        _vm.mobHasfocusoutvalue,
                                    },
                                    attrs: { for: "mobile" },
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("NewMobilenumber")) + " "
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "error-msg-hold":
                                        _vm.mobilenumberdigitisvalid,
                                    },
                                  },
                                  [
                                    _vm.mobilenumberdigitisvalid
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "error-message err-gender",
                                          },
                                          [
                                            _vm._v(
                                              "Please enter 10 digit mobile number"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "error-msg-hold":
                                        _vm.numbervalidationcustomer,
                                    },
                                  },
                                  [
                                    _vm.numbervalidationcustomer
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "error-message err-gender pt-2",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Onlynumericareallowed")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ])
                    : _c("div", { staticClass: "col-8" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: { "disable-hold": _vm.abhaprofile != null },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "container-comm",
                                class: { disabled: _vm.abhaprofile != null },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.customermobile,
                                      expression: "customermobile",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    autocomplete: "off",
                                    name: "uname",
                                    required: "",
                                    maxlength: "10",
                                  },
                                  domProps: { value: _vm.customermobile },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.customermobile = $event.target.value
                                    },
                                  },
                                }),
                                _vm._m(1),
                              ]
                            ),
                          ]
                        ),
                      ]),
                ]),
              ]),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "container-comm" }, [
                    _c(
                      "div",
                      { staticClass: "search-by-t" },
                      [
                        _c("v-autocomplete", {
                          ref: "guest_autocomplete",
                          style: _vm.readonlyparentdata
                            ? { color: "rgba(29, 29, 29, 0.45)" }
                            : {},
                          attrs: {
                            name: "Guest ID",
                            items: _vm.guestCustomers,
                            "get-label": _vm.getGuestLabel,
                            "component-item": _vm.gtemplate,
                            "auto-select-one-item": false,
                            disabled: _vm.readonlyparentdata || _vm.isEditMode,
                            "input-attrs": {
                              id: "patientid_autocomplete",
                              class: "input form-control",
                              maxlength: 15,
                            },
                          },
                          on: {
                            "update-items": _vm.updateGuestItems,
                            "item-selected": _vm.guest_selected,
                            focus: function ($event) {
                              return _vm.guestfocus(true)
                            },
                            blur: function ($event) {
                              return _vm.guestfocus(false)
                            },
                          },
                          model: {
                            value: _vm.selectedGuest,
                            callback: function ($$v) {
                              _vm.selectedGuest = $$v
                            },
                            expression: "selectedGuest",
                          },
                        }),
                        _c(
                          "label",
                          {
                            class: {
                              "animate-label-t": _vm.guestHasfocus,
                              "animate-label-t t-valid":
                                (_vm.guestHasfocusout &&
                                  _vm.guestHasfocusoutvalue) ||
                                (_vm.guestHasfocus && _vm.selectedGuest),
                            },
                          },
                          [
                            _vm._v(
                              "\n                    Search by Patient ID\n                  "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row mt-3 mb-3" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "container-comm" }, [
                    _c(
                      "div",
                      {
                        staticClass: "container-comm",
                        class: { "error-msg-hold": _vm.isfirstname },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.firstName,
                              expression: "firstName",
                            },
                          ],
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            name: "uname",
                            required: "",
                            maxlength: "50",
                            disabled: _vm.readonlyparentdata && !_vm.isEditMode,
                          },
                          domProps: { value: _vm.firstName },
                          on: {
                            keypress: _vm.allowNameKeyPress,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.firstName = $event.target.value
                            },
                          },
                        }),
                        _vm._m(2),
                        _vm.isfirstname && _vm.firstName
                          ? _c("span", { staticClass: "error-message error" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Pleaseenteralpahabetical"))
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container-comm",
                      class: { "error-msg-hold": _vm.ismiddlename },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.middleName,
                            expression: "middleName",
                          },
                        ],
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          name: "uname",
                          maxlength: "50",
                          required: "",
                          disabled: _vm.readonlyparentdata && !_vm.isEditMode,
                        },
                        domProps: { value: _vm.middleName },
                        on: {
                          keypress: _vm.allowNameKeyPress,
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.middleName = $event.target.value
                          },
                        },
                      }),
                      _vm._m(3),
                      this.ismiddlename && _vm.middleName
                        ? _c("span", { staticClass: "error-message error" }, [
                            _vm._v(_vm._s(_vm.$t("Pleaseenteralpahabetical"))),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row mt-3 mb-3" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "container-comm" }, [
                    _c(
                      "div",
                      {
                        staticClass: "container-comm",
                        class: { "error-msg-hold": _vm.islastname },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lastName,
                              expression: "lastName",
                            },
                          ],
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            name: "uname",
                            required: "",
                            maxlength: "50",
                            disabled: _vm.readonlyparentdata && !_vm.isEditMode,
                          },
                          domProps: { value: _vm.lastName },
                          on: {
                            keypress: _vm.allowNameKeyPress,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lastName = $event.target.value
                            },
                          },
                        }),
                        _vm._m(4),
                        this.islastname && _vm.lastName
                          ? _c("span", { staticClass: "error-message error" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Pleaseenteralpahabetical"))
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "col-lg-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "container-comm valid1" }, [
                    _c(
                      "div",
                      {
                        staticClass: "container-comm",
                        class: {
                          "error-msg-hold":
                            _vm.isselecteddateofbirth && !_vm.dateofbirth,
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.dateofbirth,
                              expression: "dateofbirth",
                            },
                          ],
                          staticClass: "trans-bg",
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            name: "uname",
                            required: "",
                            id: "patientsetdateofbirth",
                            placeholder: "DD-MM-YYYY",
                            disabled:
                              _vm.readonlyparentdata &&
                              _vm.hasValue(_vm.dateofbirth) &&
                              !_vm.isEditMode,
                          },
                          domProps: { value: _vm.dateofbirth },
                          on: {
                            change: _vm.updateDOBItems,
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.dateofbirth = $event.target.value
                              },
                              _vm.validateDOBInput,
                            ],
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.onDobEnter.apply(null, arguments)
                            },
                          },
                        }),
                        _vm._m(5),
                      ]
                    ),
                    _c("span", { staticClass: "date-field-in" }),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-lg-6 mt-3" },
                [
                  _vm._l(_vm.genderOptions, function (item) {
                    return _c(
                      "label",
                      { key: item.value, staticClass: "radio-container" },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.text) +
                            "\n              "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedGender,
                              expression: "selectedGender",
                            },
                          ],
                          attrs: {
                            name: "gender",
                            type: "radio",
                            disabled: _vm.readonlyparentdata && !_vm.isEditMode,
                          },
                          domProps: {
                            value: item.value,
                            checked: _vm._q(_vm.selectedGender, item.value),
                          },
                          on: {
                            change: function ($event) {
                              _vm.selectedGender = item.value
                            },
                          },
                        }),
                        _c("span", { staticClass: "radio-checkmark" }),
                      ]
                    )
                  }),
                  this.usergender && !_vm.selectedGender
                    ? _c("span", { staticClass: "error-message err-gender" }, [
                        _vm._v(_vm._s(_vm.$t("Pleaseselectgender"))),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              this.selectededitappointment
                ? _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: { "disable-hold": _vm.selectededitappointment },
                      },
                      [
                        _c("div", { staticClass: "container-comm" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.customeremail,
                                expression: "customeremail",
                              },
                            ],
                            attrs: {
                              type: "text",
                              autocomplete: "off",
                              name: "uname",
                              maxlength: "100",
                              plcaceholder: " ",
                              required: "",
                              disabled:
                                _vm.readonlyparentdata &&
                                _vm.hasValue(_vm.customeremail),
                            },
                            domProps: { value: _vm.customeremail },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.customeremail = $event.target.value
                              },
                            },
                          }),
                          _c("label", { attrs: { for: "email" } }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.$t("EmailOptional")) + " "),
                              _c("span", {
                                staticStyle: {
                                  color: "rgb(181 181 181)",
                                  "font-style": "italic",
                                },
                              }),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              !this.selectededitappointment
                ? _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: { "disable-hold": _vm.selectededitappointment },
                      },
                      [
                        _c("div", { staticClass: "container-comm" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.customeremail,
                                expression: "customeremail",
                              },
                            ],
                            attrs: {
                              type: "text",
                              autocomplete: "off",
                              name: "email",
                              plcaceholder: " ",
                              required: "",
                              maxlength: "100",
                              disabled:
                                _vm.readonlyparentdata &&
                                _vm.hasValue(_vm.customeremail) &&
                                !_vm.isEditMode,
                            },
                            domProps: { value: _vm.customeremail },
                            on: {
                              blur: _vm.ValidateEmail,
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.customeremail = $event.target.value
                              },
                            },
                          }),
                          _c("label", { attrs: { for: "email" } }, [
                            _c("b", [
                              _vm._v(_vm._s(_vm.$t("EmailOptional")) + " "),
                              _c("span", {
                                staticStyle: {
                                  color: "rgb(181 181 181)",
                                  "font-style": "italic",
                                },
                              }),
                            ]),
                          ]),
                          _c("div", { staticClass: "height-dft m-0" }, [
                            _c(
                              "div",
                              {
                                class: {
                                  "error-msg-hold": _vm.validationcustomeremail,
                                },
                              },
                              [
                                _vm.validationcustomeremail
                                  ? _c("span", { staticClass: "error" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Pleaseentervalidemailaddress")
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "container-comm" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.address,
                          expression: "address",
                        },
                      ],
                      attrs: {
                        required: "",
                        maxlength: "255",
                        disabled:
                          _vm.readonlyparentdata &&
                          _vm.hasValue(_vm.address) &&
                          !_vm.isEditMode,
                      },
                      domProps: { value: _vm.address },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.address = $event.target.value
                        },
                      },
                    }),
                    _vm._m(6),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6 mt-2" }, [
                _c("div", { staticClass: "add-notes-hold d-none" }, [
                  _c(
                    "a",
                    {
                      staticClass: "add-new-btn",
                      attrs: {
                        href: "javascript:void(0);",
                        id: "add_category",
                      },
                      on: { click: _vm.shownote },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            !_vm.note ? _vm.$t("Addnotes") : _vm.$t("Viewnotes")
                          ) +
                          "\n                "
                      ),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                    ]
                  ),
                ]),
                !this.selectededitappointment || this.appointmentByEncounter
                  ? _c("div", {
                      staticClass: "allow-over-hold-saperator",
                      attrs: { hidden: "" },
                    })
                  : _vm._e(),
                !this.selectededitappointment || this.appointmentByEncounter
                  ? _c(
                      "div",
                      {
                        staticClass: "allow-over-hold",
                        attrs: { hidden: "", allowOverlapping: "" },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "container customcheck splfont-1",
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-placement": "top",
                              title: _vm.$t("Allowoverlapping"),
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.allowOverlapping,
                                  expression: "allowOverlapping",
                                },
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.allowOverlapping)
                                  ? _vm._i(_vm.allowOverlapping, null) > -1
                                  : _vm.allowOverlapping,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.allowOverlapping,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.allowOverlapping = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.allowOverlapping = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.allowOverlapping = $$c
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "checkmark c-right" }),
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("Allowoverlapping")) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              !this.selectededitappointment || this.appointmentByEncounter
                ? _c("div", { staticClass: "col-lg-6" }, [
                    _c("div", { staticClass: "pull-right mt-2" }, [
                      _c(
                        "button",
                        {
                          staticClass: "primary-btn ripple",
                          class: { "global-disabled": _vm.isSaving },
                          attrs: { type: "button", disabled: _vm.isSaving },
                          on: {
                            click: function ($event) {
                              _vm.isEditMode
                                ? _vm.updateVIPGuest()
                                : _vm.registerVIPGuest()
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.isEditMode ? "Update" : "Save")),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "add-categoryst" }, [
              _c("div", { staticClass: "col-lg-12 mt-3 padr-0 pl-0" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "text-2000" }, [
                    _vm._v(
                      _vm._s(_vm.totalRemainCount) +
                        "/" +
                        _vm._s(_vm.limitmaxCount)
                    ),
                  ]),
                  _c("div", { staticClass: "container-TXT" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.note,
                          expression: "note",
                        },
                      ],
                      attrs: {
                        id: "apptnote",
                        rows: "4",
                        autocomplete: "off",
                        name: "uname",
                        required: "",
                        maxlength: "250",
                      },
                      domProps: { value: _vm.note },
                      on: {
                        keyup: _vm.liveCountDown,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.note = $event.target.value
                        },
                      },
                    }),
                    _c("div", { staticClass: "hide-bar-hold" }),
                    _c("label", { attrs: { for: "fname" } }, [
                      _c("b", [_vm._v(_vm._s(_vm.$t("Note")))]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm.iserrormessage
              ? _c("span", {
                  staticClass: "error-message pull-left",
                  staticStyle: { color: "red", width: "98%" },
                  domProps: { innerHTML: _vm._s(_vm.errormessage) },
                })
              : _vm._e(),
          ]),
          _c("div", { staticClass: "modal-footer" }),
        ]),
      ]),
      _vm.monepopup
        ? _c(
            "div",
            [
              _c("monecreation", {
                on: { closepopupone: _vm.closecreationpopup },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.appointmentspinner ? _c("div", [_vm._m(7)]) : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isdisplaymsg
            ? _c("Messages", {
                attrs: {
                  iserror: _vm.iserrormsg,
                  datamessage: _vm.sucessmsgtext,
                  isVisible: _vm.isdisplaymsg,
                },
                on: { closemsg: _vm.closeMessage },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("optgroup", { attrs: { label: "Other countries" } }, [
      _c("option", { attrs: { "data-countrycode": "DZ", value: "213" } }, [
        _vm._v("Algeria (+213)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AD", value: "376" } }, [
        _vm._v("Andorra (+376)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AO", value: "244" } }, [
        _vm._v("Angola (+244)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AI", value: "1264" } }, [
        _vm._v("Anguilla (+1264)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AG", value: "1268" } }, [
        _vm._v("Antigua & Barbuda (+1268)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AR", value: "54" } }, [
        _vm._v("Argentina (+54)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AM", value: "374" } }, [
        _vm._v("Armenia (+374)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AW", value: "297" } }, [
        _vm._v("Aruba (+297)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AU", value: "61" } }, [
        _vm._v("Australia (+61)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AT", value: "43" } }, [
        _vm._v("Austria (+43)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AZ", value: "994" } }, [
        _vm._v("Azerbaijan (+994)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BS", value: "1242" } }, [
        _vm._v("Bahamas (+1242)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BH", value: "973" } }, [
        _vm._v("Bahrain (+973)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BD", value: "880" } }, [
        _vm._v("Bangladesh (+880)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BB", value: "1246" } }, [
        _vm._v("Barbados (+1246)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BY", value: "375" } }, [
        _vm._v("Belarus (+375)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BE", value: "32" } }, [
        _vm._v("Belgium (+32)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BZ", value: "501" } }, [
        _vm._v("Belize (+501)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BJ", value: "229" } }, [
        _vm._v("Benin (+229)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BM", value: "1441" } }, [
        _vm._v("Bermuda (+1441)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BT", value: "975" } }, [
        _vm._v("Bhutan (+975)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BO", value: "591" } }, [
        _vm._v("Bolivia (+591)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BA", value: "387" } }, [
        _vm._v("Bosnia Herzegovina (+387)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BW", value: "267" } }, [
        _vm._v("Botswana (+267)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BR", value: "55" } }, [
        _vm._v("Brazil (+55)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BN", value: "673" } }, [
        _vm._v("Brunei (+673)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BG", value: "359" } }, [
        _vm._v("Bulgaria (+359)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BF", value: "226" } }, [
        _vm._v("Burkina Faso (+226)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "BI", value: "257" } }, [
        _vm._v("Burundi (+257)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KH", value: "855" } }, [
        _vm._v("Cambodia (+855)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CM", value: "237" } }, [
        _vm._v("Cameroon (+237)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CA", value: "1" } }, [
        _vm._v("Canada (+1)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CV", value: "238" } }, [
        _vm._v("Cape Verde Islands (+238)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KY", value: "1345" } }, [
        _vm._v("Cayman Islands (+1345)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CF", value: "236" } }, [
        _vm._v("Central African Republic (+236)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CL", value: "56" } }, [
        _vm._v("Chile (+56)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CN", value: "86" } }, [
        _vm._v("China (+86)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CO", value: "57" } }, [
        _vm._v("Colombia (+57)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KM", value: "269" } }, [
        _vm._v("Comoros (+269)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CG", value: "242" } }, [
        _vm._v("Congo (+242)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CK", value: "682" } }, [
        _vm._v("Cook Islands (+682)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CR", value: "506" } }, [
        _vm._v("Costa Rica (+506)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "HR", value: "385" } }, [
        _vm._v("Croatia (+385)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CU", value: "53" } }, [
        _vm._v("Cuba (+53)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CY", value: "90392" } }, [
        _vm._v("Cyprus North (+90392)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CY", value: "357" } }, [
        _vm._v("Cyprus South (+357)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CZ", value: "42" } }, [
        _vm._v("Czech Republic (+42)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "DK", value: "45" } }, [
        _vm._v("Denmark (+45)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "DJ", value: "253" } }, [
        _vm._v("Djibouti (+253)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "DM", value: "1809" } }, [
        _vm._v("Dominica (+1809)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "DO", value: "1809" } }, [
        _vm._v("Dominican Republic (+1809)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "EC", value: "593" } }, [
        _vm._v("Ecuador (+593)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "EG", value: "20" } }, [
        _vm._v("Egypt (+20)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SV", value: "503" } }, [
        _vm._v("El Salvador (+503)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GQ", value: "240" } }, [
        _vm._v("Equatorial Guinea (+240)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ER", value: "291" } }, [
        _vm._v("Eritrea (+291)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "EE", value: "372" } }, [
        _vm._v("Estonia (+372)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ET", value: "251" } }, [
        _vm._v("Ethiopia (+251)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "FK", value: "500" } }, [
        _vm._v("Falkland Islands (+500)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "FO", value: "298" } }, [
        _vm._v("Faroe Islands (+298)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "FJ", value: "679" } }, [
        _vm._v("Fiji (+679)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "FI", value: "358" } }, [
        _vm._v("Finland (+358)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "FR", value: "33" } }, [
        _vm._v("France (+33)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GF", value: "594" } }, [
        _vm._v("French Guiana (+594)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PF", value: "689" } }, [
        _vm._v("French Polynesia (+689)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GA", value: "241" } }, [
        _vm._v("Gabon (+241)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GM", value: "220" } }, [
        _vm._v("Gambia (+220)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GE", value: "7880" } }, [
        _vm._v("Georgia (+7880)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "DE", value: "49" } }, [
        _vm._v("Germany (+49)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GH", value: "233" } }, [
        _vm._v("Ghana (+233)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GI", value: "350" } }, [
        _vm._v("Gibraltar (+350)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GR", value: "30" } }, [
        _vm._v("Greece (+30)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GL", value: "299" } }, [
        _vm._v("Greenland (+299)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GD", value: "1473" } }, [
        _vm._v("Grenada (+1473)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GP", value: "590" } }, [
        _vm._v("Guadeloupe (+590)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GU", value: "671" } }, [
        _vm._v("Guam (+671)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GT", value: "502" } }, [
        _vm._v("Guatemala (+502)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GN", value: "224" } }, [
        _vm._v("Guinea (+224)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GW", value: "245" } }, [
        _vm._v("Guinea - Bissau (+245)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "GY", value: "592" } }, [
        _vm._v("Guyana (+592)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "HT", value: "509" } }, [
        _vm._v("Haiti (+509)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "HN", value: "504" } }, [
        _vm._v("Honduras (+504)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "HK", value: "852" } }, [
        _vm._v("Hong Kong (+852)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "HU", value: "36" } }, [
        _vm._v("Hungary (+36)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "IS", value: "354" } }, [
        _vm._v("Iceland (+354)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ID", value: "62" } }, [
        _vm._v("Indonesia (+62)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "IR", value: "98" } }, [
        _vm._v("Iran (+98)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "IQ", value: "964" } }, [
        _vm._v("Iraq (+964)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "IE", value: "353" } }, [
        _vm._v("Ireland (+353)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "IL", value: "972" } }, [
        _vm._v("Israel (+972)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "IT", value: "39" } }, [
        _vm._v("Italy (+39)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "JM", value: "1876" } }, [
        _vm._v("Jamaica (+1876)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "JP", value: "81" } }, [
        _vm._v("Japan (+81)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "JO", value: "962" } }, [
        _vm._v("Jordan (+962)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KZ", value: "7" } }, [
        _vm._v("Kazakhstan (+7)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KE", value: "254" } }, [
        _vm._v("Kenya (+254)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KI", value: "686" } }, [
        _vm._v("Kiribati (+686)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KP", value: "850" } }, [
        _vm._v("Korea North (+850)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KR", value: "82" } }, [
        _vm._v("Korea South (+82)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KW", value: "965" } }, [
        _vm._v("Kuwait (+965)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KG", value: "996" } }, [
        _vm._v("Kyrgyzstan (+996)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LA", value: "856" } }, [
        _vm._v("Laos (+856)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LV", value: "371" } }, [
        _vm._v("Latvia (+371)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LB", value: "961" } }, [
        _vm._v("Lebanon (+961)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LS", value: "266" } }, [
        _vm._v("Lesotho (+266)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LR", value: "231" } }, [
        _vm._v("Liberia (+231)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LY", value: "218" } }, [
        _vm._v("Libya (+218)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LI", value: "417" } }, [
        _vm._v("Liechtenstein (+417)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LT", value: "370" } }, [
        _vm._v("Lithuania (+370)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LU", value: "352" } }, [
        _vm._v("Luxembourg (+352)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MO", value: "853" } }, [
        _vm._v("Macao (+853)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MK", value: "389" } }, [
        _vm._v("Macedonia (+389)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MG", value: "261" } }, [
        _vm._v("Madagascar (+261)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MW", value: "265" } }, [
        _vm._v("Malawi (+265)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MY", value: "60" } }, [
        _vm._v("Malaysia (+60)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MV", value: "960" } }, [
        _vm._v("Maldives (+960)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ML", value: "223" } }, [
        _vm._v("Mali (+223)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MT", value: "356" } }, [
        _vm._v("Malta (+356)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MH", value: "692" } }, [
        _vm._v("Marshall Islands (+692)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MQ", value: "596" } }, [
        _vm._v("Martinique (+596)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MR", value: "222" } }, [
        _vm._v("Mauritania (+222)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "YT", value: "269" } }, [
        _vm._v("Mayotte (+269)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MX", value: "52" } }, [
        _vm._v("Mexico (+52)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "FM", value: "691" } }, [
        _vm._v("Micronesia (+691)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MD", value: "373" } }, [
        _vm._v("Moldova (+373)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MC", value: "377" } }, [
        _vm._v("Monaco (+377)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MN", value: "976" } }, [
        _vm._v("Mongolia (+976)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MS", value: "1664" } }, [
        _vm._v("Montserrat (+1664)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MA", value: "212" } }, [
        _vm._v("Morocco (+212)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MZ", value: "258" } }, [
        _vm._v("Mozambique (+258)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "MN", value: "95" } }, [
        _vm._v("Myanmar (+95)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NA", value: "264" } }, [
        _vm._v("Namibia (+264)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NR", value: "674" } }, [
        _vm._v("Nauru (+674)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NP", value: "977" } }, [
        _vm._v("Nepal (+977)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NL", value: "31" } }, [
        _vm._v("Netherlands (+31)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NC", value: "687" } }, [
        _vm._v("New Caledonia (+687)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NZ", value: "64" } }, [
        _vm._v("New Zealand (+64)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NI", value: "505" } }, [
        _vm._v("Nicaragua (+505)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NE", value: "227" } }, [
        _vm._v("Niger (+227)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NG", value: "234" } }, [
        _vm._v("Nigeria (+234)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NU", value: "683" } }, [
        _vm._v("Niue (+683)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NF", value: "672" } }, [
        _vm._v("Norfolk Islands (+672)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NP", value: "670" } }, [
        _vm._v("Northern Marianas (+670)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "NO", value: "47" } }, [
        _vm._v("Norway (+47)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "OM", value: "968" } }, [
        _vm._v("Oman (+968)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PW", value: "680" } }, [
        _vm._v("Palau (+680)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PA", value: "507" } }, [
        _vm._v("Panama (+507)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PG", value: "675" } }, [
        _vm._v("Papua New Guinea (+675)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PY", value: "595" } }, [
        _vm._v("Paraguay (+595)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PE", value: "51" } }, [
        _vm._v("Peru (+51)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PH", value: "63" } }, [
        _vm._v("Philippines (+63)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PL", value: "48" } }, [
        _vm._v("Poland (+48)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PT", value: "351" } }, [
        _vm._v("Portugal (+351)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "PR", value: "1787" } }, [
        _vm._v("Puerto Rico (+1787)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "QA", value: "974" } }, [
        _vm._v("Qatar (+974)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "RE", value: "262" } }, [
        _vm._v("Reunion (+262)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "RO", value: "40" } }, [
        _vm._v("Romania (+40)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "RU", value: "7" } }, [
        _vm._v("Russia (+7)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "RW", value: "250" } }, [
        _vm._v("Rwanda (+250)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SM", value: "378" } }, [
        _vm._v("San Marino (+378)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ST", value: "239" } }, [
        _vm._v("Sao Tome & Principe (+239)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SA", value: "966" } }, [
        _vm._v("Saudi Arabia (+966)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SN", value: "221" } }, [
        _vm._v("Senegal (+221)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CS", value: "381" } }, [
        _vm._v("Serbia (+381)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SC", value: "248" } }, [
        _vm._v("Seychelles (+248)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SL", value: "232" } }, [
        _vm._v("Sierra Leone (+232)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SG", value: "65" } }, [
        _vm._v("Singapore (+65)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SK", value: "421" } }, [
        _vm._v("Slovak Republic (+421)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SI", value: "386" } }, [
        _vm._v("Slovenia (+386)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SB", value: "677" } }, [
        _vm._v("Solomon Islands (+677)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SO", value: "252" } }, [
        _vm._v("Somalia (+252)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ZA", value: "27" } }, [
        _vm._v("South Africa (+27)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ES", value: "34" } }, [
        _vm._v("Spain (+34)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "LK", value: "94" } }, [
        _vm._v("Sri Lanka (+94)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SH", value: "290" } }, [
        _vm._v("St. Helena (+290)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "KN", value: "1869" } }, [
        _vm._v("St. Kitts (+1869)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SC", value: "1758" } }, [
        _vm._v("St. Lucia (+1758)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SD", value: "249" } }, [
        _vm._v("Sudan (+249)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SR", value: "597" } }, [
        _vm._v("Suriname (+597)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SZ", value: "268" } }, [
        _vm._v("Swaziland (+268)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SE", value: "46" } }, [
        _vm._v("Sweden (+46)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "CH", value: "41" } }, [
        _vm._v("Switzerland (+41)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "SI", value: "963" } }, [
        _vm._v("Syria (+963)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TW", value: "886" } }, [
        _vm._v("Taiwan (+886)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TJ", value: "7" } }, [
        _vm._v("Tajikstan (+7)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TH", value: "66" } }, [
        _vm._v("Thailand (+66)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TG", value: "228" } }, [
        _vm._v("Togo (+228)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TO", value: "676" } }, [
        _vm._v("Tonga (+676)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TT", value: "1868" } }, [
        _vm._v("Trinidad & Tobago (+1868)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TN", value: "216" } }, [
        _vm._v("Tunisia (+216)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TR", value: "90" } }, [
        _vm._v("Turkey (+90)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TM", value: "7" } }, [
        _vm._v("Turkmenistan (+7)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TM", value: "993" } }, [
        _vm._v("Turkmenistan (+993)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TC", value: "1649" } }, [
        _vm._v("Turks & Caicos Islands (+1649)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "TV", value: "688" } }, [
        _vm._v("Tuvalu (+688)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "UG", value: "256" } }, [
        _vm._v("Uganda (+256)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "UA", value: "380" } }, [
        _vm._v("Ukraine (+380)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "AE", value: "971" } }, [
        _vm._v("United Arab Emirates (+971)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "UY", value: "598" } }, [
        _vm._v("Uruguay (+598)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "UZ", value: "7" } }, [
        _vm._v("Uzbekistan (+7)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "VU", value: "678" } }, [
        _vm._v("Vanuatu (+678)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "VA", value: "379" } }, [
        _vm._v("Vatican City (+379)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "VE", value: "58" } }, [
        _vm._v("Venezuela (+58)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "VN", value: "84" } }, [
        _vm._v("Vietnam (+84)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "VG", value: "84" } }, [
        _vm._v("Virgin Islands - British (+1284)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "VI", value: "84" } }, [
        _vm._v("Virgin Islands - US (+1340)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "WF", value: "681" } }, [
        _vm._v("Wallis & Futuna (+681)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "YE", value: "969" } }, [
        _vm._v("Yemen (North)(+969)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "YE", value: "967" } }, [
        _vm._v("Yemen (South)(+967)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ZM", value: "260" } }, [
        _vm._v("Zambia (+260)"),
      ]),
      _c("option", { attrs: { "data-countrycode": "ZW", value: "263" } }, [
        _vm._v("Zimbabwe (+263)"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "fname" } }, [
      _c("b", [_vm._v("Mobile number")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "fname" } }, [
      _c("b", [_vm._v("First name ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "fname" } }, [
      _c("b", [_vm._v("Middle name (Optional) ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "fname" } }, [
      _c("b", [_vm._v("Last name ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "date-hoverB", attrs: { for: "dateofbirth" } },
      [_c("b", [_vm._v("DOB ")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "pname" } }, [
      _c("b", [_vm._v("Address")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "processing_popup full-spinner",
        staticStyle: { visibility: "visible" },
      },
      [
        _c("div", { staticClass: "spinner" }, [
          _c("div", { staticClass: "bounce1" }),
          _c("div", { staticClass: "bounce2" }),
          _c("div", { staticClass: "bounce3" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }